import { Injectable, signal } from '@angular/core';
import { IMenu } from '../models/menu-inteface';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private http: HttpClient) { }
  
  getMenu(): Observable<IMenu[]> {
    return this.http.get<IMenu[]>(`${environment.URL_VITAL_ADMIN}menu/`)
  }

  hasMenu = signal(true);
  isHideOptionsEditAccount = signal(false);

  hideMenu(){
    this.hasMenu.set(false);
  }
  showMenu(){
    this.hasMenu.set(true);
  }
  setOptionsEditAccount(value: boolean){
    this.isHideOptionsEditAccount.set(value);
  }
 
}
